import { Typography } from '@mui/material';

import { InvoiceDetailPage } from '~/components/invoices/detailPage/InvoiceDetailPage';
import { RowPreviewPanel } from '~/components/rowPreview/RowPreviewPanel';
import type { RowPreview } from '~/components/rowPreview/useRowPreview';
import { useInvoicePreview } from '~/data/hooks/useInvoice';

export function InvoicePreviewContent({ invoiceId }: { invoiceId: string }) {
  const { invoice, error, loading } = useInvoicePreview(invoiceId);
  const current = invoice && invoice.id === invoiceId ? invoice : undefined;

  if (error && !current) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 3 }}>
        This invoice couldn’t be loaded.
      </Typography>
    );
  }
  return (
    <InvoiceDetailPage
      key={invoiceId}
      invoice={current}
      isLoading={loading || !current}
      onBack={null}
      variant="preview"
    />
  );
}

export function InvoicePreviewPanel({
  rowPreview,
  onOpenFullPage,
}: {
  rowPreview: RowPreview;
  onOpenFullPage: (invoiceId: string) => void;
}) {
  return (
    <RowPreviewPanel
      rowPreview={rowPreview}
      ariaLabel="Invoice preview"
      onOpenFullPage={onOpenFullPage}
    >
      {(invoiceId) => <InvoicePreviewContent invoiceId={invoiceId} />}
    </RowPreviewPanel>
  );
}
